// src/redux/registerFormReducer.ts
import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'
import APIHelper from '../HelperMethodsForAPI'

interface RegisterFormState {
    loading: boolean
    successMessage?: string
    errorMessage?: string
}

export interface RegistrationFormData {
    FirstName: string
    LastName: string
    EmailAddress?: string
    Password: string
    ReenterPassword: string
    secId?: string | null
    samAccountName?: string | null
    // RoleId:roleSelect, TODO enable role select
    NationalProviderID?: string
    AgreeTOS?: boolean
    DomainSlashUserid?: string
    authSource?: number | null
    SiteName?: string
}

export interface RegistrationResponse {
    data: any
}

interface EmailConfirmationData {
    Id: string,
    TimeId: string
}


export const registerFormAPI = createApi({
    reducerPath: 'register', //our reducer lives at store.reducer
    tagTypes: ['RegistrationFormData'],
    baseQuery: getBaseQuery( getBaseUrl() + 'API/v3'), //The base API path
    // The "endpoints" represent operations and requests for this server
    endpoints: (build) => ({
        // The `getPosts` endpoint is a "query" operation that returns data
        submitForm: build.mutation<RegistrationResponse, Partial<RegistrationFormData>>({
            query: (body) => ({
                url: '/Account',
                method: 'POST',
                body,
            }),
        }),
        })
    })

        
    export const emailConfirmationAPI = createApi({
        reducerPath: 'emailConfirmation',
        tagTypes: ['emailConfirmation'],
        baseQuery: getBaseQuery( getBaseUrl() + 'API/v3/Page' ),
        endpoints: (builder) => ({
            emailConfirmation: builder.mutation<any, EmailConfirmationData>({
                query: (callEmailConfirmationAPI) => {
                    return {
                        url: '/emailconfirmation',
                        method: 'PUT',
                        body: APIHelper.prepareFormData (callEmailConfirmationAPI),
                    };
                },
            }),
        }),
    })
    

export const { useSubmitFormMutation } = registerFormAPI
// export const registerFormSlice;

 export const { useEmailConfirmationMutation } = emailConfirmationAPI
